export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getPaginatedMessages(_, page) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/customer/messages?page=" + page)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        deleteMessage(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/customer/messages/delete/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        replyMessage(_, data) {
            console.log(data)
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/customer/messages/reply/" + data.identifier, {
                    message: data.message
                })
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
    },
}

